module.exports = "<p>\n  <!--default works!-->\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/default/default.component.html
// module id = ../../../../../src/app/default/default.component.html
// module chunks = main